import React, { useState, useEffect } from 'react';
import './ScrollProgressBar.css';

const ScrollProgressBar = () => {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        let ticking = false;

        const updateScrollProgress = () => {
            const currentScroll = window.scrollY;
            const totalScrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
            if (totalScrollableHeight > 0) {
                const progress = (currentScroll / totalScrollableHeight) * 100;
                setScrollProgress(Math.min(100, Math.max(0, progress)));
            }
            ticking = false;
        };

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateScrollProgress);
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        updateScrollProgress();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="scroll-progress-track" aria-hidden="true">
            <div 
                className="scroll-progress-fill" 
                style={{ width: `${scrollProgress}%` }}
            />
        </div>
    );
};

export default ScrollProgressBar;
